import React, { useEffect, useState } from "react";
import { message, Pagination } from "antd";
import { FaLocationDot } from "react-icons/fa6";
import { IoSend, IoCall } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { FaHeart, FaUserCheck } from "react-icons/fa";
import { PiStudentFill } from "react-icons/pi";
import { MdOutlineWork } from "react-icons/md";
import { formatDistanceToNow as timeAgo } from "date-fns";
import {
  UserGet, UserUpdate, UserData_Array_Update, UserDataGet,
  PostChargesGet, UserTotalRevenuePost, StaffTotalRevenuePost,
  DevTotalRevenuePost, AdminTotalRevenuePost,
} from "../../Api/CoreApi";
import ProfileHeader from "./Profile_Header";
import Footer from "../../Home_Page_WLog/Footer/Footer";

function User_Auto_Match_User() {
  const Navigate = useNavigate();
  const id = localStorage.getItem("user_id");
  const admin_role = localStorage.getItem("role");

  const [User, setUser] = useState([]);
  const [alluser, setAlluser] = useState([]);
  const [data, setData] = useState([]);
  const [admin, setAdmin] = useState([]);
  const [staff_Json, setStaff_Json] = useState([]);
  const [developer, setDeveloper] = useState([]);
  const [charges, setCharges] = useState([]);
  const [reload, setReload] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const profilesPerPage = 12;

  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, "0");

  // ===== ALL BACKEND LOGIC 100% SAME =====
  const user_get = async () => {
    const response = await UserGet();
    const alluser_filter = response.filter((i) => i.role === "user");
    setAlluser(alluser_filter);
    setAdmin(response.filter((i) => i.role === "admin"));
    setStaff_Json(response.filter((i) => i.role === "staff"));
    setDeveloper(response.filter((i) => i.role === "developer"));
    const current_user = response.filter((i) => i.id === id);
    setUser(current_user);
    const response_UserDataGet = await UserDataGet();
    const user_caste_str = String(current_user.map((i) => i.caste));
    const user_geder_str = String(current_user.map((i) => i.gender));
    if (user_geder_str === "Male") {
      setData(response_UserDataGet.filter((i) => i.gender === "Female" && i.caste === user_caste_str));
    } else {
      setData(response_UserDataGet.filter((i) => i.gender === "Male" && i.caste === user_caste_str));
    }
    setCharges(await PostChargesGet());
  };

  useEffect(() => { user_get(); }, [reload]);

  const alert_popup = (i) => {
    if (window.confirm("Are you sure?")) { user_get(); distribute(i); }
  };

  const distribute = async (value) => {
    const data_id = value.User_id;
    const today = new Date().toLocaleDateString();
    if (User[0].balance > 24) {
      message.success("success");
      const charges_amount = charges.map((i) => i.post_charges);
      const amount = parseInt(charges_amount);
      const user_amount = User[0].balance;
      const commision = charges.map((i) => i.staff_commission);
      const reduce_balance = parseInt(parseInt(user_amount) - parseInt(amount));
      const response1 = await UserUpdate(id, { balance: reduce_balance });
      let ca = response1.filter((i) => i.role === "admin"); let cs = response1.filter((i) => i.role === "staff"); let cd = response1.filter((i) => i.role === "developer"); let cu = response1.filter((i) => i.id === id);
      setAdmin(ca); setStaff_Json(cs); setDeveloper(cd); setAlluser(response1); setUser(cu);
      const plateform_charge = (amount * 2) / 100;
      const after_pateform_charge = amount - plateform_charge;
      const staff_Commision = parseInt((parseInt(after_pateform_charge) * parseInt(commision)) / 100);
      const filter_staff = staff_Json.filter((i) => i.refer === value.ref);
      const staff_id = String(filter_staff.map((i) => i.id));
      if (filter_staff.length === 1) {
        const staff_balance = filter_staff.map((i) => i.balance);
        const r2 = await UserUpdate(staff_id, { balance: parseInt(staff_Commision) + parseInt(staff_balance) });
        ca = r2.filter((i) => i.role === "admin"); cs = r2.filter((i) => i.role === "staff"); cd = r2.filter((i) => i.role === "developer"); cu = r2.filter((i) => i.id === id);
        setAdmin(ca); setStaff_Json(cs); setDeveloper(cd); setAlluser(r2); setUser(cu);
        value.user_apply.push({ suser_id: id }); delete value.pic; delete value.cover_img;
        await UserData_Array_Update(data_id, value);
        await StaffTotalRevenuePost({ suser_id: id, ruser_id: data_id, staff_amount: staff_Commision, total_amount: amount, date: today, month, staff_id });
      }
      const after_staff_Commision = parseInt(after_pateform_charge) - parseInt(staff_Commision);
      const dev_commision = parseInt((after_staff_Commision * 15) / 100);
      const developer_id = String(developer.map((i) => i.id));
      const developer_balance = developer.map((i) => i.balance);
      const add_developer_balance = parseInt(developer_balance) + parseInt(dev_commision);
      const r3 = await UserUpdate(developer_id, { balance: add_developer_balance });
      ca = r3.filter((i) => i.role === "admin"); cs = r3.filter((i) => i.role === "staff"); cd = r3.filter((i) => i.role === "developer"); cu = r3.filter((i) => i.id === id);
      setAdmin(ca); setStaff_Json(cs); setDeveloper(cd); setAlluser(r3); setUser(cu);
      await DevTotalRevenuePost({ suser_id: id, ruser_id: data_id, dev_amount: dev_commision, total_amount: amount, date: today, month, dev_id: developer_id });
      const filter_Dev = developer.filter((i) => i.refer === value.ref);
      if (filter_Dev.length === 1) {
        const r4 = await UserUpdate(developer_id, { balance: parseInt(staff_Commision) + parseInt(add_developer_balance) });
        ca = r4.filter((i) => i.role === "admin"); cs = r4.filter((i) => i.role === "staff"); cd = r4.filter((i) => i.role === "developer"); cu = r4.filter((i) => i.id === id);
        setAdmin(ca); setStaff_Json(cs); setDeveloper(cd); setAlluser(r4); setUser(cu);
        value.user_apply.push({ suser_id: id }); delete value.pic; delete value.cover_img;
        await UserData_Array_Update(data_id, value);
        await DevTotalRevenuePost({ suser_id: id, ruser_id: data_id, dev_amount: dev_commision, total_amount: amount, date: today, month, dev_id: developer_id });
      }
      const admin_commision = parseInt(after_staff_Commision - dev_commision);
      const admin_scom_adcom = admin_commision + staff_Commision;
      const admin_id = String(admin.map((i) => i.id));
      const Admin_balance = admin.map((i) => i.balance);
      const add_Admin_balance = parseInt(Admin_balance) + parseInt(admin_commision);
      const r6 = await UserUpdate(admin_id, { balance: add_Admin_balance });
      ca = r6.filter((i) => i.role === "admin"); cs = r6.filter((i) => i.role === "staff"); cd = r6.filter((i) => i.role === "developer"); cu = r6.filter((i) => i.id === id);
      setAdmin(ca); setStaff_Json(cs); setDeveloper(cd); setAlluser(r6); setUser(cu);
      const filter_admin = admin.filter((i) => i.refer === value.ref && i.role === "admin");
      if (filter_admin.length === 1) {
        const r7 = await UserUpdate(admin_id, { balance: parseInt(staff_Commision) + parseInt(add_Admin_balance) });
        ca = r7.filter((i) => i.role === "admin"); cs = r7.filter((i) => i.role === "staff"); cd = r7.filter((i) => i.role === "developer"); cu = r7.filter((i) => i.id === id);
        setAdmin(ca); setStaff_Json(cs); setDeveloper(cd); setAlluser(r7); setUser(cu);
        value.user_apply.push({ suser_id: id }); delete value.pic; delete value.cover_img;
        await UserData_Array_Update(data_id, value);
        await AdminTotalRevenuePost({ suser_id: id, ruser_id: data_id, admin_amount: admin_scom_adcom, total_amount: amount, date: today, month, admin_id });
      } else {
        await AdminTotalRevenuePost({ suser_id: id, ruser_id: data_id, admin_amount: admin_commision, total_amount: amount, date: today, month, admin_id });
      }
      const filter_user = alluser.filter((i) => i.refer === value.ref && i.role === "user");
      const alluser_id = String(filter_user.map((i) => i.id));
      const alluser_balance = parseInt(filter_user.map((i) => i.balance));
      if (filter_user.length === 1) {
        const r9 = await UserUpdate(alluser_id, { balance: parseInt(staff_Commision) + parseInt(alluser_balance) });
        ca = r9.filter((i) => i.role === "admin"); cs = r9.filter((i) => i.role === "staff"); cd = r9.filter((i) => i.role === "developer"); cu = r9.filter((i) => i.id === id);
        setAdmin(ca); setStaff_Json(cs); setDeveloper(cd); setAlluser(r9); setUser(cu);
        value.user_apply.push({ suser_id: id }); delete value.pic; delete value.cover_img;
        await UserData_Array_Update(data_id, value);
        await UserTotalRevenuePost({ suser_id: id, ruser_id: data_id, user_amount: staff_Commision, total_amount: amount, date: today, month, user_id: alluser_id });
      }
      setReload(1);
    } else {
      message.error("need to add balance");
      Navigate("/User_Recharge");
      setReload(1);
    }
  };
  // ===== END BACKEND LOGIC =====

  const currentData = data.slice(
    (currentPage - 1) * profilesPerPage,
    currentPage * profilesPerPage
  );

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap');
        *{font-family:'Poppins',sans-serif!important;box-sizing:border-box}
        @keyframes amFloat{0%,100%{transform:translateY(0) rotate(0) scale(1)}50%{transform:translateY(-16px) rotate(5deg) scale(1.06)}}
        @keyframes amSlide{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:translateY(0)}}
        @keyframes amBeat{0%,100%{transform:scale(1)}25%{transform:scale(1.12)}50%{transform:scale(1)}75%{transform:scale(1.12)}}

        .am-page{background:linear-gradient(180deg,#fff 0%,#fff5f7 50%,#fff 100%);min-height:100vh}

        .am-hero{position:relative;padding:30px 20px;background:linear-gradient(135deg,#ff0044 0%,#ff3366 25%,#ff6699 55%,#ff99b5 78%,#ffc2d4 100%);overflow:hidden;text-align:center}
        .am-hero::before{content:'';position:absolute;inset:0;background:radial-gradient(circle at 20% 40%,rgba(255,255,255,.12),transparent 50%),radial-gradient(circle at 80% 20%,rgba(255,255,255,.08),transparent 45%);pointer-events:none}
        .am-hero-float{position:absolute;opacity:.13;animation:amFloat 6s ease-in-out infinite;pointer-events:none}
        .am-hero-inner{position:relative;z-index:2;max-width:700px;margin:0 auto}
        .am-hero-badge{display:inline-flex;align-items:center;gap:7px;padding:8px 16px;border-radius:999px;background:rgba(255,255,255,.18);backdrop-filter:blur(12px);border:1px solid rgba(255,255,255,.3);color:#fff;font-size:12px;font-weight:700;margin-bottom:14px}
        .am-hero-title{font-size:clamp(24px,4.5vw,40px);font-weight:900;color:#fff;margin:0 0 8px;line-height:1.18}
        .am-hero-accent{background:linear-gradient(90deg,#fff,#ffe4ec,#ffc2d4);-webkit-background-clip:text;-webkit-text-fill-color:transparent}
        .am-hero-sub{font-size:clamp(12px,1.8vw,15px);color:rgba(255,255,255,.9);max-width:500px;margin:0 auto 18px;line-height:1.7}
        .am-hero-stats{display:flex;justify-content:center;gap:12px;flex-wrap:wrap}
        .am-stat{display:flex;flex-direction:column;align-items:center;padding:10px 16px;min-width:95px;background:rgba(255,255,255,.14);backdrop-filter:blur(14px);border-radius:16px;border:1.5px solid rgba(255,255,255,.22);color:#fff}
        .am-stat-num{font-size:18px;font-weight:800}
        .am-stat-label{font-size:10px;color:rgba(255,255,255,.82);font-weight:500}

        .am-section{max-width:1200px;margin:0 auto;padding:32px 16px 50px}
        .am-section-head{text-align:center;margin-bottom:28px}
        .am-section-badge{display:inline-block;padding:7px 16px;border-radius:999px;background:linear-gradient(135deg,#ff0055,#ff4d88);color:#fff;font-size:12px;font-weight:700;box-shadow:0 6px 16px rgba(255,0,85,.16);margin-bottom:12px}
        .am-section-title{font-size:clamp(22px,3.5vw,34px);font-weight:800;color:#1a0a10;margin:0 0 6px}
        .am-accent{background:linear-gradient(135deg,#ff0055,#ff4d88);-webkit-background-clip:text;-webkit-text-fill-color:transparent}
        .am-section-sub{font-size:14px;color:#888;max-width:500px;margin:0 auto}

        .am-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));gap:18px}

        .am-card{background:#fff;border-radius:22px;overflow:hidden;border:2px solid #ffe4ec;box-shadow:0 8px 24px rgba(255,0,85,.05);transition:all .38s ease;animation:amSlide .5s ease;display:flex;flex-direction:column}
        .am-card:hover{transform:translateY(-6px);border-color:#ff80aa;box-shadow:0 18px 42px rgba(255,0,85,.12)}

        .am-card-inner{display:flex;gap:14px;padding:16px;text-decoration:none;color:inherit;flex:1}
        .am-card-img{width:130px;height:180px;border-radius:16px;object-fit:cover;flex-shrink:0;border:2px solid #ffe4ec;transition:transform .4s ease}
        .am-card:hover .am-card-img{transform:scale(1.04)}

        .am-card-info{flex:1;display:flex;flex-direction:column;gap:5px;justify-content:center}
        .am-card-name{font-size:18px;font-weight:700;color:#1a0a10;margin:0}
        .am-card-detail{display:flex;align-items:center;gap:6px;font-size:12.5px;color:#777}
        .am-card-detail svg{color:#ff4d88;font-size:13px;flex-shrink:0}
        .am-card-time{font-size:11px;color:#aaa;font-style:italic;margin-top:auto}

        .am-card-actions{display:flex;gap:8px;padding:0 16px 14px;justify-content:flex-end}
        .am-action-btn{height:36px;border:none;border-radius:12px;padding:0 16px;font-size:12px;font-weight:700;cursor:pointer;display:flex;align-items:center;gap:6px;transition:all .3s ease}
        .am-action-btn:hover{transform:translateY(-2px)}
        .am-call-btn{background:linear-gradient(135deg,#16a34a,#22c55e);color:#fff;box-shadow:0 6px 16px rgba(34,197,94,.18)}
        .am-send-btn{background:linear-gradient(135deg,#ff0055,#ff4d88);color:#fff;box-shadow:0 6px 16px rgba(255,0,85,.18)}

        .am-pagination{display:flex;justify-content:center;margin-top:28px;grid-column:1/-1}
        .am-pagination .ant-pagination-item{border-radius:10px!important;border:1.5px solid #ffd7e3!important}
        .am-pagination .ant-pagination-item a{color:#c2185b!important;font-weight:600}
        .am-pagination .ant-pagination-item-active{background:linear-gradient(135deg,#ff0055,#ff4d88)!important;border-color:#ff0055!important}
        .am-pagination .ant-pagination-item-active a{color:#fff!important}

        .am-empty{grid-column:1/-1;text-align:center;padding:50px 20px;background:#fff;border-radius:22px;border:2px solid #ffe4ec}
        .am-empty-icon{font-size:48px;margin-bottom:12px;display:block;animation:amBeat 2s infinite}
        .am-empty h3{font-size:20px;font-weight:700;color:#c2185b;margin:0 0 6px}
        .am-empty p{font-size:13px;color:#888;margin:0}

        @media(max-width:768px){
          .am-hero{padding:24px 14px}
          .am-grid{grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:14px}
          .am-card-img{width:110px;height:150px}
          .am-card-name{font-size:16px}
          .am-section{padding:24px 12px 40px}
        }
        @media(max-width:480px){
          .am-grid{grid-template-columns:1fr}
          .am-card-inner{flex-direction:column;align-items:center;text-align:center}
          .am-card-img{width:100%;max-width:220px;height:200px}
          .am-card-detail{justify-content:center}
          .am-card-actions{justify-content:center}
        }
      `}</style>

      <ProfileHeader />
      <div style={{ paddingTop: "70px" }}></div>

      <div className="am-page">
        {/* Hero */}
        <section className="am-hero">
          {["💖","💍","💕","🌹","✨","❤️"].map((e,i) => (
            <span key={i} className="am-hero-float" style={{
              top:`${10+((i*9)%65)}%`, left:`${5+((i*12)%82)}%`,
              fontSize:`${16+(i%4)*4}px`, animationDelay:`${i*0.4}s`
            }}>{e}</span>
          ))}
          <div className="am-hero-inner">
            <div className="am-hero-badge">💖 Smart Matching</div>
            <h1 className="am-hero-title">Your <span className="am-hero-accent">Best Matches</span></h1>
            <p className="am-hero-sub">Profiles matching your caste and preference — handpicked for you</p>
            <div className="am-hero-stats">
              <div className="am-stat"><span className="am-stat-num">{data.length}</span><span className="am-stat-label">Matches</span></div>
              <div className="am-stat"><span className="am-stat-num">💖</span><span className="am-stat-label">Compatible</span></div>
              <div className="am-stat"><span className="am-stat-num">✅</span><span className="am-stat-label">Verified</span></div>
            </div>
          </div>
        </section>

        {/* Profiles */}
        <section className="am-section">
          <div className="am-section-head">
            <span className="am-section-badge">Matching Profiles</span>
            <h2 className="am-section-title">Compatible <span className="am-accent">Profiles</span> For You</h2>
            <p className="am-section-sub">Based on your caste and gender preference</p>
          </div>

          <div className="am-grid">
            {currentData.length > 0 ? (
              currentData.map((i) => (
                <div className="am-card" key={i.User_id}>
                  <Link to={`/User_data/${i.User_id}`} className="am-card-inner">
                    <img
                      src={`${i.pic}`}
                      alt={i.firstname}
                      className="am-card-img"
                      onError={(e) => { e.target.src = "https://via.placeholder.com/180"; }}
                    />
                    <div className="am-card-info">
                      <h3 className="am-card-name">{i.firstname}</h3>
                      <span className="am-card-detail">🎂 Age: {i.age}</span>
                      <span className="am-card-detail">🕉️ {i.religion}</span>
                      <span className="am-card-detail"><PiStudentFill /> {i.course}</span>
                      <span className="am-card-detail"><MdOutlineWork /> {i.job_title}</span>
                      <span className="am-card-detail"><FaLocationDot /> {i.district}</span>
                      <span className="am-card-time">
                        {i.create_date && !isNaN(new Date(i.create_date))
                          ? timeAgo(new Date(i.create_date), { addSuffix: true }).replace("about ", "")
                          : "—"}
                      </span>
                    </div>
                  </Link>
                  <div className="am-card-actions">
                    {i.user_apply?.some((u) => u.suser_id === id) ? (
                      <button className="am-action-btn am-call-btn" onClick={() => (window.location.href = `tel:${i.contact}`)}>
                        <IoCall /> Call
                      </button>
                    ) : (
                      <button className="am-action-btn am-send-btn" onClick={() => alert_popup(i)}>
                        <IoSend /> Connect
                      </button>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="am-empty">
                <span className="am-empty-icon">💕</span>
                <h3>No Matches Found</h3>
                <p>We're working to find compatible profiles for you</p>
              </div>
            )}

            <div className="am-pagination">
              <Pagination
                current={currentPage}
                pageSize={profilesPerPage}
                total={data.length}
                onChange={(page) => { setCurrentPage(page); window.scrollTo({ top: 0, behavior: "smooth" }); }}
                showSizeChanger={false}
              />
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}

export default User_Auto_Match_User;